export const MixpanelEvents = {
  SIMULATION_STARTED: "Simulation Started",
  SIMULATION_COMPLETED: "Simulation Completed",
  MODULE_DIALOG_OPENED: "Module Dialog Opened",
  MODULE_DIALOG_CLOSED: "Module Dialog Closed",
} as const;

export interface SimulationStartProperties {
  moduleName?: string;
  scenario?: string;
  toleranceLevel?: number;
}

export interface SimulationCompleteProperties {
  moduleName?: string;
  scenario?: string;
  toleranceLevel?: number;
  stressLevel?: number;
  timeSpentSeconds?: number;
}

export interface ModuleDialogProperties {
  moduleId?: string;
  moduleName?: string;
  dialogTitle?: string;
}
